import React from 'react';
import '../css/Loading.css'; // Importamos el archivo de estilos CSS

const Loading = () => {
  return (
    <div className='loading-overlay'>
      <div className='wrapper'>
        <section className='loaders loaders-bg-4'>
          <span className='loader loader-bars'>
            <span></span>
          </span> 
          Cargando...
        </section>
      </div>
    </div>
  );
};

export default Loading;
